<template>
  <!-- sign in start -->
  <section class="authentication-form">
    <div class="innerpage-decor">
    </div>
    <div>
      <h2 class="title text-center"><router-link to="/"><img :src='"../../assets/images/efunding-logo.png"'
            alt="logo-brand"></router-link></h2>
      <p class="text-center">Selamat datang di efunding, Silahkan Masuk.</p>
      <div class="card login-card">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form class="theme-form" @submit.prevent="handleSubmit(handleLogin)">
            <b-alert v-model="loginFailAlert" variant="danger" dismissible>
              {{ messageError ? messageError : 'Email atau Password salah!' }}
            </b-alert>
            <b-alert v-model="NoroleMessage" variant="danger" dismissible>
              Akun Anda tidak berhak masuk di web ini
            </b-alert>
            <div class="form-group">
              <ValidationProvider name="email" rules="required|email" required v-slot="{ errors }">
                <input type="email" v-model="form.email" class="form-control" placeholder="email" name="email">
                <small class="text-danger ml-3">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
            <ValidationProvider name="password" rules="required" v-slot="{ errors }">
              <div class="form-group">
                <input :type="showpassword ? 'password' : 'text'" v-model="form.password" name="password"
                  class="form-control" placeholder="Password">
                <div v-on:click="showpassword = !showpassword" class="show-hide">
                  <span :class="{ show: showpassword }"></span>
                </div>
                <div class="row  ml-3">
                  <small class="text-danger">{{ errors[0] }}</small>
                </div>
              </div>
            </ValidationProvider>
            <div class="form-group row">
              <div class="col text-left">
                <router-link to="/forgot-password" class="text-left theme-link">Lupa Password?</router-link>
              </div>
              <div class="col text-right">
                <router-link to="/register" @click="goToNavbar" class="text-right theme-link">Belum punya akun?</router-link>
              </div>
            </div>
            <div class="form-button text-center">
              <button type="submit" class="btn btn-custom btn-lg theme-color" :disabled="loading">
                <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                <span>Login</span>
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
    <!--strat color change -->
    <!--end color change-->
    <b-modal size="l" v-model="emailNullModal">
      <div class="d-block text-center">
        <h3>Email Anda belum terverifikasi.<br>Silahkan cek Email Anda!</h3>
      </div>

      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="oke">Oke</b-button>
        <!-- <b-button variant="primary" @click="confirm">Oke</b-button> -->
      </template>
    </b-modal>
  </section>
  <!-- sign in end-->
</template>
<script>

import { extend } from 'vee-validate';
// import { required, email } from 'vee-validate/dist/rules';
import AuthMe from "../../api/auth/authentication"
import checkAgreementStatus from "../../helpers/agreementStatus"


export default {
  name: 'Login',
  data() {
    return {
      showpassword: true,
      loginFailAlert: false,
      form: {
        email: '',
        password: ''
      },
      message: '',
      loading: false,
      currentUser: '',
      emailNullModal: false,
      _path: '',
      NoroleMessage: false,
      messageError: '',
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  created() {
    let redirectTo
    if (this.loggedIn) {
      // redirectTo =
      redirectTo = this.$store.state.auth.user.info.role_id === 5 ? '/dashboard' : '/pengajuan-saya'
      this.$router.push(redirectTo);
      this.currentUser = this.$store.state.auth.user
      // console.log(currentUser)
    }
  },
  methods: {
    handleLogin() {
      this.loading = true;

      this.$store.dispatch('auth/login', this.form)
        .then((res) => {
          // Ambil data user setelah login sukses
          AuthMe.getMe().then(res => {
            if (res.data.meta.code === 200) {
              const user = res.data.data;
              const roleName = user.role.name;
              const emailVerified = user.email_verified_at;
              let redirectTo = '/efunding';
              let validRole = true;

              switch (roleName) {
                case 'funder-personal':
                case 'funder-non-personal':
                  redirectTo = '/pengajuan-saya';
                  break;
                case 'mitra':
                  redirectTo = '/dashboard';
                  break;
                case 'marketing-agency':
                  redirectTo = '/agency/dashboard';
                  break;
                default:
                  validRole = false;
                  this.NoroleMessage = true;
                  this.loading = false;
                  this.$store.dispatch('auth/logout').then(() => {
                    this.$router.push('/login');
                  })
                  return;
              }

              // Cek persetujuan SNK, Kebijakan Privasi, dan syarat Tilaka (khusus
              // nasabah) memakai aturan yang sama dengan router guard.
              return checkAgreementStatus(user).then(agreementStatus => {
                if (agreementStatus.unauthenticated) {
                  localStorage.removeItem('user');
                  this.messageError = 'Sesi Anda telah berakhir. Silakan login kembali.';
                  this.loginFailAlert = true;
                  this.loading = false;
                  return;
                }

                if (agreementStatus.needAgreement) {
                  this.$router.push('/agreement');
                  this.loading = false;
                  return;
                }

                if (res.data.data.is_default_password == true) {
                  this.$router.push('/default-password-change');
                  this.loading = false;
                  return;
                }

                // Jika role valid, cek email verifikasi
                if (emailVerified === null) {
                  this.emailNullModal = true;
                  this.$router.push('/wait-verify-email');
                } else {
                  this.$router.push(redirectTo);
                }

                this.loading = false;
              });

            } else {
              // Bukan soal hak akses: data profil gagal dibaca, biarkan user mencoba lagi.
              this.messageError = res.data.meta.message || 'Gagal memuat data akun. Silakan coba lagi.';
              this.loginFailAlert = true;
              this.loading = false;
            }
          }).catch(err => {
            console.error('Gagal ambil data me:', err);
            this.handleGetMeError(err);
          });
        })
        .catch(err => {
          console.log('Login failed');
          this.loginFailAlert = true;
          this.messageError = this.extractMessage(err);
          this.loading = false;
        });
    },

    /**
     * Kegagalan membaca profil bukan berarti user tidak berhak masuk. Pesan
     * "tidak berhak" hanya dipakai untuk role yang memang tidak dilayani web ini.
     */
    handleGetMeError(err) {
      const response = err && err.response;
      const status = response && response.status;
      const meta = response && response.data && response.data.meta;

      if (status === 401 || (meta && meta.code == 401)) {
        localStorage.removeItem('user');
        this.messageError = 'Sesi Anda telah berakhir. Silakan login kembali.';
        this.loginFailAlert = true;
      } else if (status === 403) {
        // Masih ada persetujuan yang belum diberikan.
        this.$router.push('/agreement');
      } else {
        this.messageError = 'Gagal memuat data akun. Silakan coba lagi.';
        this.loginFailAlert = true;
      }

      this.loading = false;
    },

    extractMessage(err) {
      if (typeof err === 'string') {
        return err;
      }

      const meta = err && err.response && err.response.data && err.response.data.meta;

      if (meta && meta.message) {
        return meta.message;
      }

      return 'Email atau Password salah!';
    },
    hideSuccessModal() {
      this.emailNullModal = false;
    },
    oke() {
      this.emailNullModal = false;
    },
    goToNavbar() {
      this.$router.push('/register');
      this.$nextTick(() => {
        this.registerFormOpen();
      });

    }

  }
}
</script>
<style scoped>
.login-card {
  width: 500px;
  margin: 0 auto;
  padding: 2rem;
}

@media (max-width: 768px) {
  .login-card {
    width: 90%;
    padding: 1rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/public/auth/login.vue